// import '../styles/Cnc.scss'

import '../styles/ProductsWithList.scss';

const Cnc = () => {
    return (
        <div className="main">
            <h1>CNC Machining</h1>
            <img className='img-maxum-logo' src='https://user-images.githubusercontent.com/77664153/180502025-d02877f3-628c-4f40-9fee-662ed406c23c.png' alt='Maxum CNC Logo'></img>
            <p></p>
            <h3 className='external-link'>To learn more about our CNC Machining Services, please visit <a href='http://www.maxumcnc.com' target="_blank" rel='noreferrer'>maxumcnc.com</a></h3>
        </div>
    );
};

export default Cnc;
